jQuery(document).ready(function($) {

  function showHide(showEl, hideEl){
    $(showEl).css('display', 'block');
    $(hideEl).css('display', 'none');
  }
  
  $(window).on('load gform_page_loaded', function(event, form_id, current_page){

    
  
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Hide/Show Fields
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if($('.m-field__buttons')[0]){

      const budgetButton = $('#budgetAmount');
      const dollarButton = $('#dollarAmount');
      const field        = $('.m-field__single--large');
      const radio        = $('.m-field__radio');
      
      $(budgetButton).click(function(){
        showHide(dollarButton, budgetButton);
        showHide(radio, field);
      });

      $(dollarButton).click(function(){
        showHide(budgetButton, dollarButton);
        showHide(field, radio);
      });
    }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Custom Next Button
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if($('.gform_next_button')[0]){
      const nextButton  = $('.js-next-page');
        
      $(nextButton).on('click', function(){
        const gnextButton = $(this).closest('.gform_page').find('.gform_next_button');
        
        gnextButton.click();
      });
    }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Submit
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    if($('#gform_submit_button_3')[0]){
      const submitButton    = $('.js-submit');
      
      $(submitButton).on('click', function(){
        const oldSubmitButton = $(this).closest('.gform_page').find('#gform_submit_button_3');

        oldSubmitButton.click();
      });
    }
  });
});